export default __webpack_public_path__ + "static/IN-9008-vs-IN-5907_WA_resTestBig-8b7742102371fa158dac9c834cefe1c3.webp";